import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';

import { Provider } from 'react-redux';
import configureStore from './store/configureStore';

// Configure redux store
const preloadedState = {};
const store = configureStore(preloadedState);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider >,
    document.getElementById('root'),
);

// Remove registrations from older releases without bundling the CRA service-worker helper.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations => registrations.forEach(registration => registration.unregister()));
  });
}
